import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large login-container"
  }, [_c("BackgroundVideo"), _c("div", {
    staticClass: "container-centered small-2"
  }, [_c("h1", [_vm._v("Sign in")]), _c("div", {
    staticClass: "login-form"
  }, [_c("div", [_c(VTextField, {
    attrs: {
      label: "Email address",
      placeholder: "john.doe@domain.com",
      autofocus: ""
    },
    model: {
      value: _vm.input.login,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "login", $$v);
      },
      expression: "input.login"
    }
  }), _vm.loginError.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(_vm._s(_vm.loginError))]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "white-append-icon",
    attrs: {
      label: "Password",
      type: _vm.isShowPassword ? "text" : "password"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c("span", {
          staticClass: "cursor--pointer",
          on: {
            click: function click($event) {
              _vm.isShowPassword = !_vm.isShowPassword;
            }
          }
        }, [!_vm.isShowPassword ? _c(VIcon, [_vm._v("mdi-eye")]) : _c(VIcon, [_vm._v("mdi-eye-off")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.input.password,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "password", $$v);
      },
      expression: "input.password"
    }
  }), _vm.passwordError.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.passwordError) + ". "), _c("a", {
    on: {
      click: _vm.resetPassword
    }
  }, [_vm._v("Click here to reset your password ?")])]) : _vm._e()], 1)]), _vm.isCaptchaEnabled ? _c("div", {
    staticClass: "captcha"
  }, [_c("vue-hcaptcha", {
    ref: "hCaptchaRef",
    attrs: {
      sitekey: _vm.hCaptchaSiteKey
    },
    on: {
      verify: _vm.captchaVerifiedCallback
    }
  }), _vm.captchaError.length > 0 ? _c("p", {
    staticClass: "errorLabel captcha-error"
  }, [_vm._v(" " + _vm._s(_vm.captchaError) + " ")]) : _vm._e()], 1) : _vm._e(), _c("div", {
    attrs: {
      id: "login-button-container"
    }
  }, [_c(VBtn, {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ["enter"],
      expression: "['enter']"
    }],
    staticClass: "login-button",
    attrs: {
      loading: _vm.isLoading
    },
    on: {
      click: _vm.login
    },
    nativeOn: {
      shortkey: function shortkey($event) {
        return _vm.login();
      }
    }
  }, [_vm._v(" SIGN IN ")])], 1), _c("div", {
    attrs: {
      id: "other-actions"
    }
  }, [_c("a", {
    on: {
      click: function click($event) {
        return _vm.resetPassword();
      }
    }
  }, [_vm._v("Forgotten password ?")]), _c("br"), _c("span", {
    staticClass: "mr-1"
  }, [_vm._v("New user ?")]), _c("a", {
    on: {
      click: function click($event) {
        return _vm.create();
      }
    }
  }, [_vm._v("Subscribe for an account")])])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };